import {
  captchaAPI,
  sendSMSCodeAPI,
  signInAndRegisterFromSMSAPI,
  signInAPI,
  signInSMSPhoneAPI,
  signInTokenAPI,
} from '../helpers/api';
import request from '../helpers/request';

export const signIn = async (data) => {
  return await request(signInAPI(), 'POST', data);
};

export const signInWithToken = async (data) => {
  return await request(signInTokenAPI(), 'POST', data);
};

export const signInAndRegisterFromSMS = async (data) => {
  return await request(signInAndRegisterFromSMSAPI(), 'POST', data);
};

export const sendSMSCode = async (data) => {
  return await request(sendSMSCodeAPI(), 'POST', data);
};

export const signInSMSPhone = async (data) => {
  return await request(signInSMSPhoneAPI(), 'POST', data);
};

export const checkCaptcha = async (data) => {
  return await request(captchaAPI(), 'POST', data);
};
